<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { authState, logout } from '../utils/auth';

const open = ref(false);
const root = ref<HTMLElement>();
const user = computed(() => authState.user);
const initial = computed(() => (user.value?.email || user.value?.username || '?').charAt(0).toUpperCase());

const onClickOutside = (event: MouseEvent) => {
  if (root.value && !root.value.contains(event.target as Node)) open.value = false;
};
onMounted(() => document.addEventListener('click', onClickOutside));
onBeforeUnmount(() => document.removeEventListener('click', onClickOutside));
</script>

<template>
  <div ref="root" class="user-menu">
    <button class="avatar" :aria-expanded="open" aria-label="User menu" @click="open = !open">{{ initial }}</button>
    <div v-if="open" class="dropdown card" role="menu">
      <div class="who">
        <strong>{{ user?.email || user?.username }}</strong>
        <div v-if="user?.username && user?.email" class="muted mono">{{ user.username }}</div>
        <div v-if="user?.groups.length" class="groups">
          <span v-for="g in user.groups" :key="g" class="badge badge-neutral">{{ g }}</span>
        </div>
      </div>
      <button class="btn btn-danger" style="width: 100%" role="menuitem" @click="logout">Sign out</button>
    </div>
  </div>
</template>

<style scoped>
.user-menu { position: relative; }
.avatar { width: 34px; height: 34px; border-radius: 50%; border: 0; background: var(--primary); color: #fff; font-weight: 700; cursor: pointer; }
.dropdown { position: absolute; right: 0; top: 42px; width: 260px; padding: 14px; z-index: 20; }
.who { margin-bottom: 12px; word-break: break-all; }
.groups { display: flex; gap: 4px; flex-wrap: wrap; margin-top: 6px; }
</style>
